import { Component } from '@angular/core';
import { ProgressFacadeService } from '../../services/progress.facade.service';

@Component({
    selector: 'dragonfly-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.scss'],
    standalone: false
})
export class ProgressSpinnerComponent {
  constructor(public progress: ProgressFacadeService) {}
}
